<div class="splash-screen">
    <div class="image text-white">
        <div class="top-figure"></div>
        <div class="splash-title">
            <img class="logo" src="assets/FINTRAX_LOGO_WHITE.svg" />
            <h2 class="pb-2" i18n="@@logo.part1">Haal meer</h2>
            <h2 i18n=@@logo.part2>uit je tijd</h2>
        </div>
        <div class="bottom-figure">
            <div class="bottom-figure-diagonal"></div>
            <div class="bottom-figure-straight"></div>
        </div>
    </div>
    <div class="col-start-2 max-h-full overflow-y-auto">
        <div class="relative flex items-center justify-center min-h-full" [class.background]="background">
            <app-locale-switch class="absolute top-2 right-4" [options]="{minimized: true}" />
            <ng-content></ng-content>
        </div>
    </div>
</div>
